import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { AjaxService } from '../ajax.service';
import { RecordFormPage } from '../record-form/record-form.page';

@Component({
    selector: 'app-bedrijven',
    templateUrl: './bedrijven.page.html',
    styleUrls: ['./bedrijven.page.scss'],
    standalone: false
})
export class BedrijvenPage implements OnInit {

    inpID = '';
    bedrChoices = [];
    bedrData: any;
    bedrContacts: any;
    bedrFailliet = false;
    newOrderAllowed: false;
    @ViewChild('inpIDRef', {static: false}) inpIDRef: ElementRef;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public alertController: AlertController,
        public modalController: ModalController,
        private ajax: AjaxService,
    ) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            if (params.bedrid) {
                this.inpID = params.bedrid;
                this.getBedrData();
            } else {
                this.inpID = localStorage.getItem('lastBedr');
                if (this.inpID) {
                    this.getBedrData();
                }
            };
        });
        this.getBedrData();
    }

    doClearSrch() {
        this.inpID = '';
        this.inpIDRef.nativeElement.focus();
    }

    inpIDChanged(event, byclick: boolean) {
        console.log('inpIDChanged:', event, byclick);
        this.ajax.get('comboChoices', {
            table: 'bedrijven',
            txt: event
        })
        .then((data: any) => {
            if (!data.login) {
                this.router.navigateByUrl('login');
            } else {
                console.log('comboChoices:', data);
                this.bedrChoices = (data.choices) ? data.choices : [];
                if (this.bedrChoices.length === 1 || byclick) {
                    this.getBedrData();
                }
            }
        });
    }

    getBedrData() {
        console.log('get data:', this.inpID);
        this.ajax.get('bedrData', {
            ID: this.inpID
        })
        .then((data: any) => {
            if (!data.login) {
                this.router.navigateByUrl('login');
            } else {
                console.log('getBedrData:', data);
                this.bedrData = data.bedr;
                this.bedrContacts = data.cont;
                this.newOrderAllowed = (data.grp.includes('planning') || data.grp.includes('apporder'));
                this.bedrFailliet = (this.bedrData.BedrStatus === '9');
            }
        });
        localStorage.setItem('lastBedr', this.inpID);
    }

    async addBedr() {
        const myDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'bedrijven',
                id: '*NEW*',
                defaults: {
                },
            }
        });
        myDlg.onDidDismiss()
        .then(data => {
            this.inpID = data.data.id; // nw ingevoerd ID
            this.getBedrData();
        });
        return await myDlg.present();
    }

    async addOrdr() {
        const adrRegels = this.bedrData.BedrAdres.split('\n');
        let postcode = '';
        let plaats = '';
        if (adrRegels.length > 1) {
            const wp = adrRegels[1];
            const match = wp.match(/^([0-9]{4,5}\s?[A-Z]{2}?)\s+(.*)/i);
            postcode = (match) ? match[1] : '';
            plaats = (match) ? match[2] : wp;
        }
        const myDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'orders',
                id: '*NEW*',
                defaults: {
                    KlantRef: this.inpID,
                    Object: this.bedrData.BedrNaam,
                    WerkStraat: this.bedrData.BedrAdres.split('\n')[0],
                    WerkPostcode: postcode,
                    WerkPlaats: plaats,
                },
            }
        });
        myDlg.onDidDismiss()
        .then(data => {
            if (data && data.data && data.data.id) {
                console.log('order aangemaakt:', data.data.id);
                localStorage.setItem('lastProjNr', data.data.id);
                this.router.navigateByUrl('orders');
            }
        });
        return await myDlg.present();
    }

    mapsUrl(adr: string) {
        return 'https://www.google.com/maps/dir/?api=1&destination='
        + adr.replace(/(?:\r\n|\r|\n)/g, ',');
    }
}
